<template>
    <div class="card reveal-bottom">
        <img :src="img" alt="img" class="img" />
        <h3 class="card-name">{{ $t(name) }}</h3>
        <p class="card-p">{{ $t(position) }}</p>
        <div class="card-mark">
            <p class="card-desc">{{ $t(description) }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        img: String,
        name: String,
        position: String,
        description: String,
    },
};
</script>
<style scoped>
.card {
    width: 280px;
    height: 370px;
    background: #f2f2f2;
    padding: 20px 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    float: left;
    margin-right: 20px;
    position: relative;
}
.card-mark {
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(0, 163, 209, 0);
    top: 0;
    left: 0;
    transition: all 0.5s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.card:hover .card-mark {
    background: rgba(0, 163, 209, 0.7);
}
.card:hover .card-name {
    z-index: 1;
    color: #fff;
}
.card:hover .card-p {
    z-index: 1;
    color: rgba(255, 255, 255, 0.5);
}
.img {
    display: block;
    max-width: 256px;
    max-height: 256px;
    margin: auto;
}
.card-name {
    bottom: 58px;
    font-size: 18px;
    color: #000000;
    font-weight: bold;
    line-height: 27px;
    position: absolute;
    transition: all 0.5s linear;
}
.card-p {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 18px;
    top: 316px;
    position: absolute;
    transition: all 0.5s linear;
}
.card-desc {
    box-sizing: border-box;
    padding: 10px 23px 90px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    letter-spacing: 0.1px;
    text-align: justify;
    line-height: 20px;
    opacity: 0;
    transition: all 0.5s linear;
}
.card:hover .card-desc {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/Pages/ExpertTeam/Card.vue